import { c as _c } from "react/compiler-runtime";
import { FileText } from "react-feather";
import { Distribution, Donation, TaxYearlyReport, TaxYearlyReportUnits } from "../../../../../models";
import { thousandize } from "../../../../../util/formatting";
import { GenericList } from "../GenericList";
import { ListRow } from "../GenericListRow";
import { TaxYearlyReportDesktopDetails } from "./TaxYearlyReportDesktopDetails";
import style from "./TaxYearlyReportList.module.scss";
import { TaxYearlyReportListBody } from "./TaxYearlyReportListBody";
import { TaxYearlyReportListSupplemental } from "./TaxYearlyReportListSupplemental";
import { AggregatedImpactTableConfiguration } from "../../../donations/DonationsAggregateImpactTable/DonationsAggregateImpactTable";
export const TaxYearlyReportList: React.FC<{
  report: TaxYearlyReport;
  donations: Donation[];
  distribtionMap: Map<string, Distribution>;
  aggregateImpactConfig: AggregatedImpactTableConfiguration;
}> = t0 => {
  const $ = _c(48);
  const {
    report,
    donations,
    distribtionMap,
    aggregateImpactConfig
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      label: "Skatteenhet",
      width: "25%"
    };
    t2 = {
      label: "Enhetsnummer",
      width: "25%"
    };
    t3 = {
      label: "Skattefradrag",
      width: "25%"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [t1, t2, t3, {
      label: "Sum donasjoner",
      width: "25%",
      align: "right" as "right"
    }];
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const headers = t4;
  const currentYear = new Date().getFullYear();
  const t5 = report.year === currentYear - 1 ? "Mangler enhet" : "Manglet enhet";
  const t6 = report.units.length == 0 ? "Registrer en skatteenhet i fanen til venstre i menyen under \"skatt\" og alle donasjoner vil knyttes til den. Ta kontakt p\xE5 donasjon@gieffektivt.no om du \xF8nsker \xE5 knytte donasjonene dine til flere skatteenheter." : "Du har allerede en eller flere skatteenheter. Kontakt oss p\xE5 donasjon@gieffektivt.no for \xE5 knytte donasjonene dine til rett skatteenhet.";
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = {
      value: t5,
      tooltip: t6
    };
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      value: "-"
    };
    t9 = {
      value: "-"
    };
    $[7] = t8;
    $[8] = t9;
  } else {
    t8 = $[7];
    t9 = $[8];
  }
  let t10;
  if ($[9] !== report.sumDonationsWithoutTaxUnit.sumDonations) {
    t10 = thousandize(Math.round(report.sumDonationsWithoutTaxUnit.sumDonations));
    $[9] = report.sumDonationsWithoutTaxUnit.sumDonations;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  const t11 = t10 + " kr";
  let t12;
  if ($[11] !== t11) {
    t12 = {
      value: t11,
      align: "right" as "right"
    };
    $[11] = t11;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t12 || $[14] !== t7) {
    t13 = [t7, t8, t9, t12];
    $[13] = t12;
    $[14] = t7;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== report.sumDonationsWithoutTaxUnit.channels) {
    t14 = report.sumDonationsWithoutTaxUnit.channels.filter(_temp);
    $[16] = report.sumDonationsWithoutTaxUnit.channels;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t14) {
    t15 = <TaxYearlyReportDesktopDetails channels={t14} />;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== report.sumDonationsWithoutTaxUnit || $[21] !== t13 || $[22] !== t15) {
    t16 = {
      id: "missingTaxUnits",
      defaultExpanded: false,
      cells: t13,
      details: t15,
      element: report.sumDonationsWithoutTaxUnit
    };
    $[20] = report.sumDonationsWithoutTaxUnit;
    $[21] = t13;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  const rowMissingTaxUnits = t16;
  let rows;
  if ($[24] !== report.sumDonationsWithoutTaxUnit.sumDonations || $[25] !== report.units || $[26] !== rowMissingTaxUnits) {
    const rowsUnits = report.units.map(_temp2);
    rows = [...rowsUnits];
    if (report.sumDonationsWithoutTaxUnit.sumDonations > 0) {
      rows.push(rowMissingTaxUnits);
    }
    $[24] = report.sumDonationsWithoutTaxUnit.sumDonations;
    $[25] = report.units;
    $[26] = rowMissingTaxUnits;
    $[27] = rows;
  } else {
    rows = $[27];
  }
  let t17;
  if ($[28] !== report.year) {
    t17 = report.year.toString();
    $[28] = report.year;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  const t18 = `Vi har ikke registrert noen donasjoner på deg i ${t17}. Om dette ikke stemmer ta kontakt med oss
      på donasjon@gieffektivt.no.`;
  let t19;
  if ($[30] !== t18) {
    t19 = <div>{t18}</div>;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  const emptyPlaceholder = t19;
  let t20;
  if ($[32] !== report.year) {
    t20 = report.year.toString();
    $[32] = report.year;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== aggregateImpactConfig || $[35] !== distribtionMap || $[36] !== donations || $[37] !== report) {
    t21 = <TaxYearlyReportListSupplemental report={report} donations={donations} distribtionMap={distribtionMap} aggregateImpactConfig={aggregateImpactConfig} />;
    $[34] = aggregateImpactConfig;
    $[35] = distribtionMap;
    $[36] = donations;
    $[37] = report;
    $[38] = t21;
  } else {
    t21 = $[38];
  }
  let t22;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = [30, 60];
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== report) {
    t23 = <TaxYearlyReportListBody report={report} />;
    $[40] = report;
    $[41] = t23;
  } else {
    t23 = $[41];
  }
  let t24;
  if ($[42] !== emptyPlaceholder || $[43] !== rows || $[44] !== t20 || $[45] !== t21 || $[46] !== t23) {
    t24 = <div className={style.wrapper}><GenericList title={t20} headers={headers} rows={rows} emptyPlaceholder={emptyPlaceholder} expandable={true} supplementalInformation={t21} proportions={t22}>{t23}</GenericList></div>;
    $[42] = emptyPlaceholder;
    $[43] = rows;
    $[44] = t20;
    $[45] = t21;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  return t24;
};
function _temp(c) {
  return c.sumDonations > 0;
}
function _temp2(unit) {
  return {
    id: unit.id.toString(),
    defaultExpanded: false,
    cells: [{
      value: unit.name
    }, {
      value: unit.ssn
    }, {
      value: thousandize(Math.round(unit.taxDeduction)) + " kr"
    }, {
      value: thousandize(Math.round(unit.sumDonations)) + " kr",
      align: "right" as "right"
    }],
    details: <TaxYearlyReportDesktopDetails channels={unit.channels} unit={unit} />,
    element: unit
  };
}